/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: useTelephonyDomainsList.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Hook for fetching telephony domains list data.
────────────────────────────────────────────────────────────────*/

import { useCallback } from 'react';
import { useAuthStore } from '../../../store/auth';
import { getDomains } from '../api/telephonyDomainsApi';
import type { Domain } from '../types';
import type { DataGridFetchResult } from '../../../hooks/useDataGrid';

export function useTelephonyDomainsList() {
  const { user } = useAuthStore();
  const tenantSlug = user?.tenant?.slug ?? 'main';

  const fetchTenants = useCallback(
    async (params: {
      page: number;
      limit: number;
      sortBy: string;
      sortOrder: 'asc' | 'desc';
      search?: string;
    }) => {
      const response = await getDomains({
        ...params,
        tenantSlug,
        userId: user?.id
      });

      const data: Domain[] = Array.isArray(response.data) ? response.data : [];
      const pagination = response.pagination ?? {
        page: params.page,
        limit: params.limit,
        total: 0,
        totalPages: 0
      };

      return { data, pagination } as DataGridFetchResult;
    },
    [tenantSlug, user?.id]
  );

  return { fetchTenants };
}

